import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-payment-add',
    templateUrl: './payment-add.component.html',
    styleUrls: ['./payment-add.component.scss'],
    standalone: false
})
export class PaymentAddComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit() {
  }

}
